import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=416346fe&scoped=true&"
var script = {}
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=416346fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416346fe",
  null
  
)

export default component.exports